import RenderSteps from "./RenderSteps";
import "./index.css"; // <-- Add this line

export default function AddCourse() {
  return (
    <div className="add-course-container">
      <div className="add-course-main">
        <h1 className="add-course-heading">Add Course</h1>
        <div className="add-course-steps">
          <RenderSteps />
        </div>
      </div>

      {/* Course Upload Tips */}
      <div className="course-tips">
        <p className="course-tips-title">⚡ Course Upload Tips</p>
        <ul className="course-tips-list">
          <li>Set the Course Price greater 0 </li>
          <li>Standard size for the course thumbnail is 1024x576.</li>
          <li>Video section controls the course overview video.</li>
          <li>Course Builder is where you create & organize a course.</li>
          <li>
            Add Topics in the Course Builder section to create lessons,
            quizzes, and assignments.
          </li>
          <li>
            Information from the Additional Data section shows up on the
            course single page.
          </li>
          <li>Make sure video length is upto 15-20 MB</li>
          <li>Notes to all enrolled students at once.</li>
        </ul>
      </div>
    </div>
  );
}
